import styled from 'styled-components';
import { spacing } from 'ui/theme';

import { AncestorIdData, AncestorNameData, FolderId } from 'modules/domains/foldering';

import { SingleFolder } from './SingleFolder';
import { StyledLink } from './FolderName';

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${spacing.base};
  padding: 0;

  ${StyledLink} {
    text-decoration: none;
    cursor: text;
  }
`;

type Props = {
  /** element id passed for use as a key as a child of FormField */
  id: string;
  /** folder object with name and ancestors */
  folderAncestors: (AncestorIdData & AncestorNameData)[];
  /** Function run when the folder location is altered */
  onChange: (
    folderId: FolderId,
    folderName: string,
    newFolderLocation: (AncestorIdData & AncestorNameData)[],
  ) => void;
};

export const FolderLocation = ({ folderAncestors, onChange, ...otherProps }: Props) => {
  const handleSelect = (folderId: FolderId, folderName: string) => {
    const selectedIndex = folderAncestors.findIndex((folder) => folder.id === folderId);
    onChange(folderId, folderName, folderAncestors.slice(0, selectedIndex + 1));
  };

  return (
    <StyledContainer {...otherProps}>
      {folderAncestors.map((folder, idx, arr) => (
        <SingleFolder
          data={folder}
          key={`folder-${folder.id}`}
          folderIndex={idx}
          nameOverride={idx === 0 ? 'All' : ''}
          onSelect={handleSelect}
          pathLength={arr.length}
        />
      ))}
    </StyledContainer>
  );
};
